// notificationSlice.js
import { createSlice } from '@reduxjs/toolkit';

export const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    message: null,
    type: null,
    color: null // Add color to the initial state
  },
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload?.message;
      state.type = action.payload?.type || 'info';
      state.color = action.payload?.color || ''; // Default color is white
    },
    hideNotification: (state) => {
      state.message = null;
      state.type = null;
      state.color = null;
    }
  }
});

export const { showNotification, hideNotification } = notificationSlice.actions;

export const selectNotification = (state) => state.notification;

export default notificationSlice.reducer;
